import { render } from "./sport-live-tv-dialog.vue?vue&type=template&id=b6fcf780&scoped=true"
const script = {}

import "./sport-live-tv-dialog.vue?vue&type=style&index=0&id=b6fcf780&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6fcf780"]])

export default __exports__